module.exports = __webpack_public_path__ + "static/logo-8caf096c69d29d0ebd9f18eea372fcc2.svg";